<template>
  <button class="button filter-button" :class="{'_active': active, '_menuOpen': menuOpen, '_error': error}" @keyup.esc="handleCloseFilter">
    <slot name="button-start" />
    <span>{{ name }}</span>
    <div v-if="active" class="filter-tag"><span>{{ tagValue }}</span></div>
    <SVGIcon
      v-else
      :mirrored="menuOpen"
      :iconName="'expand_more'"
      :width="'20px'"
      :height="'20px'"
    />
  </button>
</template>

<script>
import SVGIcon from '@/components/SVGIcon.vue';

export default {
  name: "BaseFilterButton",
  components: {
    SVGIcon,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    tagValue: {
      type: String,
      default: '',
    },
    menuOpen: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
};
</script>


